import request from '@/services/interceptor.js'

export const get_aziende = () => {
    return request({ url: '/tenant', method: 'get', loadingBar: true })
}

export const get_azienda = (id) => {
    return request({ url: `/tenant/${id}`, method: 'get', loadingBar: true })
}

export const create_azienda = (par) => {
    return request({ url: '/tenant', method: 'post', data: par, loadingBar: true })
}

export const update_azienda = (id, par) => {
    return request({ url: `/tenant/${id}`, method: 'put', data: par, loadingBar: true })
}

export const attiva_azienda = (id) => {
    return request({ url: `/tenant/${id}/attiva`, method: 'put', loadingBar: true })
}

export const disattiva_azienda = (id) => {
    return request({ url: `/tenant/${id}/disattiva`, method: 'put', loadingBar: true })
}